import {RevenueType} from "@app/shared";

export class PeriodRevenue {
  id: number;
  version: number;
  revenueAmountAtTarget: number;
  revenueAmountRecognized: number;
  revenueAmountAtActual: number;
  revenueAmountAtBid: number;
  revenueAmountAtForecast: number;
  revenueType: RevenueType;
  invoiced: boolean;
  recognized: boolean;

  //for serialization
  orgId: number;
  customerInvoiceId: number;
  laborItemId: number;
  expenseItemId: number;
  accountingPeriodId: number;
  purchaseReturnId: number;
  contractId: number;
  clinId: number;
  projectId: number;

  //for transient
  startDate: string;
  revisedRevenueAmountRecognized?: number;
}
